import SelectComponent from 'formiojs/components/select/Select';

export default class Beacon extends SelectComponent {
    static schema(...extend) {
        return SelectComponent.schema({
            type: 'beacon',
            label: 'Beacon',
            key: 'beacon',
            data: {
                values: [
                    {'value': 'yes', 'label': 'Yes'},
                    {'value': 'no', 'label': 'No'}
                ]
            }
        }, ...extend);
    }

    static get builderInfo() {
        return {
            title: 'Beacon',
            group: 'basic',
            icon: 'html5',
            preview: false,
            documentation: '/userguide/forms/form-components#select',
            weight: 5,
            schema: Beacon.schema()
        };
    }
}
